import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const PendingJobsAndSafetyList = {
	name: NAME,
	apiProvider,
	router,
};
